import React from 'react';
import styled from 'styled-components';
import { HTTP_ERROR_IMAGES } from '../constants';
import { SelectionApp } from '../types/app';
import { getInitialState } from '../helpers/client/next.initial/getInitialState';

export const Wrapper = styled.div`
    img {
        max-width: 100%;
        margin: 95px auto -55px;
        display: block;
    }

    div {
        min-width: 320px;
        max-width: 1340px;
        margin: 0 auto 40px;
        padding: 45px 38px;
    }
`;

interface Props {
    statusCode: number | null | undefined;
}

const Error = ({ statusCode }: Props) => (
    <Wrapper>
        <img alt={statusCode?.toString() || '500'} src={HTTP_ERROR_IMAGES[statusCode || 500]} />
        <div />
    </Wrapper>
);

Error.getInitialProps = async (ctx: SelectionApp.PageContext) => {
    let originalUrl = '';

    if (ctx.req) {
        const protocol = ctx.req.headers['x-forwarded-proto'] || 'http';
        const host = ctx.req.headers.host;
        originalUrl = `${protocol}://${host}${ctx.asPath}`;
    } else if (typeof window !== 'undefined') {
        originalUrl = window.location.href;
    }

    return {
        initialState: getInitialState(ctx),
        pageName: 'error',
        statusCode: ctx.res ? ctx.res.statusCode : ctx.err ? ctx.err.statusCode : null,
        originalUrl,
    };
};

export default Error;
